import React from 'react'
import classes from './ButtonsPopup.module.css';
import { AccessibilityPopup } from '@skillz/accessibility';

const ButtonsPopup = ({ children, className, accessibilityDescription }) => {
    return <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={() => console.log('close')}>
        <div className={`${classes.ButtonsPopup} ${className}`}>
            {children}
        </div>
    </AccessibilityPopup>
}
export default ButtonsPopup;